import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d49ca208"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slider" }
const _hoisted_2 = { class: "slider__container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "slider__togglers"
}
const _hoisted_5 = ["onClick"]

import { ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSlider',
  props: {
    slides: {},
    value: {},
    useToggle: { type: Boolean },
    useNextButton: { type: Boolean }
  },
  emits: ["finish"],
  setup(__props: any, { emit }) {

const props = __props;




const currentSlide: Ref<number> = ref(props.value ?? 1);
function nextSlide() {
	if (currentSlide.value < props.slides) {
		currentSlide.value++;
	} else {
		emit('finish');
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
        return (_openBlock(), _createElementBlock("div", {
          key: slide,
          class: _normalizeClass(`slider__slide ${
					currentSlide.value == slide ? 'slider__slide-active' : ''
				}`)
        }, [
          _renderSlot(_ctx.$slots, slide),
          (_ctx.useNextButton !== false)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _withModifiers(nextSlide, ["prevent"]),
                class: "slider__slide_button button button-dark button-md"
              }, " Продолжить ", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    (_ctx.useToggle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
            return (_openBlock(), _createElementBlock("button", {
              key: slide,
              class: _normalizeClass(`slider__toggler ${
					currentSlide.value == slide ? 'slider__toggler-active' : ''
				}`),
              onClick: _withModifiers(($event: any) => (currentSlide.value = slide), ["prevent"])
            }, null, 10, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})